import * as React from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../redux';
import {InjectedFormProps, reduxForm} from 'redux-form';

import View from './view';
import {ProductsCategoryFilterForm} from '../model';
import {Forms} from '../../../../shared/models/forms';
import {productCategoriesSelector} from '../../../../redux/selectors/products';
import {getListProductCategories} from '../../../../redux/actions/products';

export interface ProductsCategoryFilterProps {
  visuallyImpaired?: boolean;
  onFilterApply?: (formData: ProductsCategoryFilterForm) => void;
}

const _ProductsCategoryFilter: React.FC<
  ProductsCategoryFilterProps & InjectedFormProps<ProductsCategoryFilterForm, ProductsCategoryFilterProps>
> = ({onFilterApply = () => undefined, handleSubmit, ...props}) => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getListProductCategories());
  }, []);

  const productCategories = useSelector(productCategoriesSelector());
  const onSubmit = React.useCallback((e: any) => {
    e?.preventDefault();
    handleSubmit(onFilterApply)();
  }, []);

  return <View onSubmit={onSubmit} productCategories={productCategories} {...props} />;
};

export const ProductsCategoryFilter = reduxForm<ProductsCategoryFilterForm, ProductsCategoryFilterProps>({
  form: Forms.productsCategoryFilterForm,
  destroyOnUnmount: false,
})(_ProductsCategoryFilter);
